/**
 * index.tsx
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { FC }          from 'react';
import { Rating }      from '~/components/rating';
import { styles }      from './styles';
import { WidgetProps } from './types';
import { ConfigContext } from '~/contexts/config';

export const Widget: FC<WidgetProps> = (props) => (
  <div css={styles.container}>
    <div css={styles.inner}>
      <ConfigContext.Provider value={props.config}>
        <Rating />
      </ConfigContext.Provider>
    </div>
  </div>
);
